import Vue from 'vue';
import store from '@/store';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let Instance = null;

export const I18n = function({ messages, lang, numberFormats }) {
    // 单例
    if (Instance === null) {
        Instance = new VueI18n({
            locale: lang || store.getters.locale || 'zh-CN',
            messages: messages || store.getters.langInfo || {},
            [lang]: {
                currency: {
                    style: 'decimal',
                    currency: 'USD'
                }
            },
            fallbackLocale: 'zh-CN',
            silentFallbackWarn: true,
            ...numberFormats
        });
    }
    return Instance;
};

/**
 *
 * @param lang.key
 * @param params.defaultText 当翻译key不存在的时候将会默认显示改文本
 * @returns translateContent
 */
export const _$t = function (key, params) {
    // 判断语言包key是否存在
    let translatedContent = null;
    if (Instance) {
        const { messages, locale } = Instance;
        translatedContent = Instance._exist(messages[locale], key);
    }
    if (translatedContent) {
        return Instance.t(key, params);
    } else if (params) {
        if (params.defaultText) {
            return params.defaultText;
        } else {
            return key;
        }
    } else {
        return key;
    }
};

// VUE混入
export const I18nMixins = {
    methods: {
        _$t(key, params) {
            return _$t(key, params);
        },
        $translate(key, params) {
            return _$t(key, params);
        }
    }
};

/**
 *
 * 语言代码 http://www.lingoes.cn/zh/translator/langcode.htm
 *
 * 在非Vue文件使用国际化，如config.js
 * import I18n from '@/utils/i18n';
 * {
        'label': I18n().t('lang.key1'),
        'prop': 'code',
        'width': 200
    }
     <el-table-column
     prop="id"
     :label="$t.('tableColumn.columnName1')"
     width="180">
 *
 *
 *
 * 在Vue内部使用国际化
 * 1.在html中引用     <el-button>{{$t.('lang.key')}}</el-button>
 * 2.在标签中使用      <el-form-item label="$t.('lang.key')" ></el-form-item>
 * 3.在VUE的js中调用   this.$t('lang.key1')
 *
 * 在配置的js文件内 注意、
 * 正确示例
 * tableColumn={
 *   columnName1:lang.key1,
 *   columnName2:lang.key3,
 * }
 * <el-table-column
     prop="id"
     :label="$t.('tableColumn.columnName1')"
     width="180">
 * 错误示范
 * tableColumn={
 *   columnName1:this.t('lang.key1'),
 *   columnName2:this.t('lang.key2'),
 * }
 * <el-table-column
     prop="id"
     :label="tableColumn.columnName1"
     width="180">
 */
